import { createContext, useContext } from 'react';

export const AuthContext: any = createContext(null);

export const useAuth: any = () => {
  return useContext(AuthContext);
}